import React, { createContext, useContext, useEffect, useState } from "react";
import { api, auth } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(auth.getUser());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = auth.getToken();
    if (!t || user) return;
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      auth.setUser(r.data);
    }).catch(() => auth.logout());
  }, []); // eslint-disable-line

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      auth.setToken(data.access_token);
      auth.setUser(data.user);
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const register = async (name, email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      auth.setToken(data.access_token);
      auth.setUser(data.user);
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = () => { auth.logout(); setUser(null); };

  // Called after external auth flows (e.g. Stripe-first signup) so the header
  // updates without a full reload.
  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      auth.setUser(data);
      return data;
    } catch { return null; }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
